<div class="modal-dialog m-0 change-password-width">
  <div class="modal-content">
    <app-modal-header-common
      title="Change Password"
      [dialogRef]="dialogRef"
    ></app-modal-header-common>

    <form [formGroup]="form" (ngSubmit)="submit()">
      <div class="modal-body">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Current password</mat-label>
          <div class="d-flex">
            <input
              matInput
              [type]="show.old_password ? 'text' : 'password'"
              formControlName="old_password"
              autocomplete="current-password"
            />
            <span
              (click)="show.old_password = !show.old_password"
              class="my-icon"
              [ngClass]="show.old_password ? 'fas fa-eye-slash' : 'far fa-eye'"
            ></span>
          </div>
        </mat-form-field>
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>New password</mat-label>
          <div class="d-flex">
            <input
              matInput
              [type]="show.new_password ? 'text' : 'password'"
              formControlName="new_password"
              autocomplete="new-password"
            />
            <span
              (click)="show.new_password = !show.new_password"
              class="my-icon"
              [ngClass]="show.new_password ? 'fas fa-eye-slash' : 'far fa-eye'"
            ></span>
          </div>
        </mat-form-field>
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Confirm new password</mat-label>
          <div class="d-flex">
            <input
              matInput
              [type]="show.confirm_password ? 'text' : 'password'"
              formControlName="confirm_password"
              autocomplete="new-password"
            />
            <span
              (click)="show.confirm_password = !show.confirm_password"
              class="my-icon"
              [ngClass]="show.confirm_password ? 'fas fa-eye-slash' : 'far fa-eye'"
            ></span>
          </div>
        </mat-form-field>

        <div class="password-rules">
          <p class="mb-1">New password must have:</p>
          <ul class="mb-0">
            <li>At least 8 characters</li>
            <li>At least one uppercase letter</li>
            <li>At least one number</li>
            <li>At least one special character</li>
          </ul>
        </div>
      </div>

      <div class="modal-footer">
        <div class="row">
          <div class="col-md-6">
            <button
              type="button"
              (click)="dialogRef.close()"
              mat-flat-button
              class="w-100 border bg-light"
            >
              Cancel
            </button>
          </div>
          <div class="col-md-6">
            <button
              type="submit"
              mat-flat-button
              class="w-100"
              color="primary"
              [disabled]="!canSubmit"
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
